const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again.';

const CLEANUP_PATTERNS = [
  /^undefined$/i,
  /^null$/i,
  /^\[object Object\]$/i,
  /^internal server error$/i,
  /^request failed with status code \d+$/i,
];

const normalizeText = (value) => String(value || '').replace(/\s+/g, ' ').trim();

const looksUnsafe = (message) => {
  if (!message) return true;
  if (message.startsWith('{') || message.startsWith('[')) return true;
  return CLEANUP_PATTERNS.some((pattern) => pattern.test(message));
};

const pickMessageFromValidationErrors = (errors) => {
  if (!Array.isArray(errors) || errors.length === 0) return '';

  const parts = errors
    .map((item) => {
      if (typeof item === 'string') return normalizeText(item);
      if (item && typeof item.message === 'string') return normalizeText(item.message);
      return '';
    })
    .filter(Boolean);

  return parts.join(' • ');
};

export const getUserFacingError = (error, fallback = DEFAULT_ERROR_MESSAGE) => {
  const validationMessage = pickMessageFromValidationErrors(error?.response?.data?.errors);
  if (validationMessage) {
    return validationMessage;
  }

  const candidates = [
    error?.response?.data?.message,
    error?.response?.data?.error,
    error?.message,
  ];

  for (const candidate of candidates) {
    const message = normalizeText(candidate);
    if (!looksUnsafe(message)) {
      return message;
    }
  }

  return fallback;
};

export default getUserFacingError;
